import React from "react";
import { Input, Table } from 'antd';
import { CopyOutlined } from '@ant-design/icons';
import { getCurrentShopId } from "../shop/get-current-shop";
import usePagination from "../../components/pagination";
import SwitchShop from "../shop/switch-shop";
import dayjs from "dayjs";
import clipboard from "../../utils/clipboard";

const statusMap = {
    0 : '待审核',
    1: '审核中',
    2: '生效',
    3: '失效',
};

const versionMap = {
    1: '基础版',
    2: '专业版',
    3: '连锁版',
};

export default () => {
    const [joins, setJoins] = React.useState([]);
    const { pagination, setTotal } = usePagination({
        onChange: (page, pageSize) => {
            getJoinList(page, pageSize).then(res => {
                setJoins(res.rows);
                setTotal(res.count);
            });
        },
    });
    const columns = [
      {
        title: '名称',
        dataIndex: 'targetAcc',
        render: (acc) => {
          return <span>{acc.companyName || acc.realname}</span>;
        },
      },
      {
        title: '注册时间',
        dataIndex: 'targetAcc',
        render: (acc) => dayjs(acc.createTime).format('YYYY-MM-DD'),
      },
      {
        title: '版本',
        dataIndex: 'targetAcc',
        render: (acc) => versionMap[acc.versionId],
      },
      {
        title: '状态',
        dataIndex: 'targetAcc',
        render: (acc) => statusMap[acc.status],
      },
      {
        title: '邀请时间',
        dataIndex: 'createTime',
        render: (createTime) => dayjs(createTime).format('YYYY-MM-DD'),
      },
      {
        title: '邀请人',
        dataIndex: 'user',
        render: (user) => user.username,
      },
      {
        title: '操作',
        fixed: 'right',
        render: () => {
            return <a>佣金流水</a>
        },
      },
    ];

    React.useEffect(() => {
        getJoinList().then(res => {
            setJoins(res.rows);
            setTotal(res.count);
        });
    }, [])

    const getJoinList = async (page = 1, pageSize = 10) => { 
        const shopId = await getCurrentShopId();
        const response = await fetch(`/api/join/list?shopId=${shopId}&page=${page}&pageSize=${pageSize}`);
        const result = await response.json();

        if(result?.success) {
            return result.data;
        }else{
            return [];
        }
    }

    const getInviteUrl = async () => {
        const shopId = await getCurrentShopId();
        
        return `https://yxdj.tech/regist?shopId=${shopId}&userId=${window.__baseInfo.userId}`;
    }

    const renderMobileCardList = () => {
        return (
            <div className="space-y-3">
                {joins.map((item) => (
                    <div key={item.id} className="admin-card p-4 active:scale-[0.98] transition-transform">
                        {/* 头部：名称和状态 */}
                        <div className="flex justify-between items-start mb-3">
                            <h3 className="font-semibold text-text-primary">
                                {item.targetAcc.companyName || item.targetAcc.realname}
                            </h3>
                            <span className={`px-2 py-1 rounded text-xs ${
                                item.targetAcc.status === 2 ? 'bg-green-100 text-green-700' :
                                item.targetAcc.status === 3 ? 'bg-gray-100 text-gray-700' :
                                'bg-yellow-100 text-yellow-700'
                            }`}>
                                {statusMap[item.targetAcc.status]}
                            </span>
                        </div>
                        
                        {/* 详细信息 */}
                        <div className="space-y-2 text-sm text-text-secondary mb-3">
                            <div className="flex justify-between">
                                <span>版本:</span>
                                <span>{versionMap[item.targetAcc.versionId]}</span>
                            </div>
                            <div className="flex justify-between">
                                <span>注册时间:</span>
                                <span>{dayjs(item.targetAcc.createTime).format('YYYY-MM-DD')}</span>
                            </div>
                            <div className="flex justify-between">
                                <span>邀请时间:</span>
                                <span>{dayjs(item.createTime).format('YYYY-MM-DD')}</span>
                            </div>
                            <div className="flex justify-between">
                                <span>邀请人:</span>
                                <span>{item.user.username}</span>
                            </div>
                        </div>
                        
                        {/* 操作按钮 */}
                        <div className="pt-3 border-t border-border-light flex justify-end">
                            <a className="text-primary text-sm hover:underline">佣金流水</a>
                        </div>
                    </div>
                ))}
            </div>
        );
    };

    return (
        <div className="space-y-4">
            <SwitchShop />
            
            <div className="admin-card p-4">
                <h3 className="admin-section-title m-0 mb-3">邀请流程</h3>
                <ol className="space-y-2 text-sm">
                    <li className="flex items-start gap-2">
                        <span className="text-primary font-semibold">1、</span>
                        <span>
                            <a 
                                onClick={async() => {
                                    clipboard(await getInviteUrl(), '邀请链接已复制，发送给你的邀请对象即可。')
                                }}
                                className="text-primary hover:underline inline-flex items-center gap-1"
                            >
                                <CopyOutlined /> 复制邀请链接(点击复制)
                            </a>
                        </span>
                    </li>
                    <li className="flex items-start gap-2">
                        <span className="text-primary font-semibold">2、</span>
                        <span>发送链接给邀请对象</span>
                    </li>
                    <li className="flex items-start gap-2">
                        <span className="text-primary font-semibold">3、</span>
                        <span>被邀请者注册</span>
                    </li>
                    <li className="flex items-start gap-2">
                        <span className="text-primary font-semibold">4、</span>
                        <span>邀请成功！</span>
                    </li>
                </ol>
            </div>
            
            <div>
                <h3 className="admin-section-title">邀请列表(已入驻)</h3>
                <div className="hidden md:block">
                    <Table rowKey={'id'} columns={columns} dataSource={joins} pagination={pagination} scroll={{ x: 'max-content' }} />
                </div>
                <div className="md:hidden">
                    {renderMobileCardList()}
                </div>
            </div>
        </div>
    )
}